import React,{Component} from 'react';
import { NavLink } from 'react-router-dom';
import Footer from './partials/Footer';


class Privacy extends React.Component {

    componentWillMount () {
        
        const script = document.createElement("script");
     
        script.src = "/assets/js/menutoggle.js";
       
        script.async = true;
     
        document.body.appendChild(script);
       
      }
      
      render(){
 
        return(
            <div class="privacypageupperdiv">
            <div class="main-banner companybg newonetop pri">
        
                <div class="container">
                
                <header class="main-header d-flex justify-content-between">
               <div class="site-logo">
                  
                  <NavLink to="/">SearchFeed</NavLink>
               </div>
               <div class="menu-toggle-icon">
                  <span class="hamburger-inner"></span>
               </div>
               <div class="site-login">
                  <div class="menu-toggle-bg"></div>
                  <div class="site-login-inner">
                     <div class="site-logo menu-with-logo">
                     <NavLink to="/">SearchFeed</NavLink>
                     </div>
                      
                     <NavLink to="/quote" className="mr-4 top-link mobi">Get a Quote</NavLink>
                      <NavLink to="/signals" className="mr-4 top-link mobi">Signals</NavLink>
                     <NavLink to="/" className="mr-4 top-link desk">Home</NavLink>
                      <NavLink to="/signals" className="mr-4 top-link desk">Signals</NavLink>
                                                              <NavLink to="/careers" className="mr-4 top-link">Careers</NavLink>
                                                              <NavLink to="/" className="mr-4 top-link mobi">Login</NavLink>
                                                              <NavLink to="/company" className="mr-4 top-link">Company</NavLink> 
                                                              {/* <NavLink to="/" className="mr-4 top-link desk">Login</NavLink> */}
                     <NavLink to="/quote" className="btn btn-lg btn-flat btn-outline ml-3 desk get33">Get a Quote</NavLink>
                  </div>
               </div>
            </header>
                
            </div> </div> 
    
               <section class="g-grid-container">
    <div class="style_hero__w3pq9">
        <div class="style_heroText__eAMRr">
            <h1>Privacy</h1>
            <p>
                Lorem Ipsum is simply dummy text of the printing and 
                typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s.
            </p>
            <div><input type="text" placeholder="Search by company name" value="" class="g-type-body g-integration-search-input" /></div>
        </div>
    </div>
    <div class="style_containerLarge__389Nl">
        <menu class="Filters_filterTabs__1GBuH">
            <li class="Filters_filterTabTrigger__3Y5oQ"><span class="Filters_tabLabel__ouoMI Filters_activeFilterTab__-8M_i">All</span></li>
            <li class="Filters_filterTabTrigger__3Y5oQ"><span class="Filters_tabLabel__ouoMI">Cloud Partners</span></li>
            <li class="Filters_filterTabTrigger__3Y5oQ"><span class="Filters_tabLabel__ouoMI">Technology Partners</span></li>
            <li class="Filters_filterTabTrigger__3Y5oQ"><span class="Filters_tabLabel__ouoMI">Systems Integrators</span></li>
        </menu>
        <menu class="GlobalFilters_globalFilters__Xyzk-">
           
            <li class="Filters_filterTabTrigger__3Y5oQ"><span class="Filters_tabLabel__ouoMI">Product</span></li>
        </menu>
    </div>
    
    <div class="style_partnerWrapper__3RcAa">
        <h3>Lorem Ipsum</h3>
        <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum</p>
    </div>
  </section>

    
    
       
           <Footer />
        </div>
        );
    }
}

export default Privacy;